// One seller plan, billed per dealership location — every user at a location is covered.
// Buying is free. Mirrors backend/src/tiers.js.
export const SELLER_PLAN = 'seller';
export const PRICE_PER_LOCATION = 500;

export function planLabel(tierId) {
  return tierId === SELLER_PLAN ? 'Seller' : tierId;
}

// Monthly price for an account with this many locations (at least one).
export function planPrice(locationCount) {
  return Math.max(1, Number(locationCount) || 1) * PRICE_PER_LOCATION;
}
